import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6245981f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dropdownItem border-bottom"
}
const _hoisted_2 = { style: {"height":"1rem","width":"0.8rem"} }
const _hoisted_3 = {
  key: 1,
  class: "dropdownItem border-bottom"
}
const _hoisted_4 = { style: {"height":"1rem","width":"0.8rem"} }
const _hoisted_5 = {
  key: 2,
  class: "dropdownItem border-bottom"
}
const _hoisted_6 = { style: {"height":"1rem","width":"0.7rem"} }
const _hoisted_7 = {
  key: 3,
  class: "dropdownItem border-bottom"
}
const _hoisted_8 = { style: {"height":"1rem","width":"0.7rem"} }
const _hoisted_9 = {
  key: 4,
  class: "dropdownItem border-bottom"
}
const _hoisted_10 = { style: {"height":"1rem","width":"0.8rem"} }
const _hoisted_11 = {
  key: 5,
  class: "dropdownItem border-bottom"
}
const _hoisted_12 = { style: {"height":"1rem","width":"0.8rem"} }
const _hoisted_13 = {
  key: 6,
  class: "dropdownItem border-bottom"
}
const _hoisted_14 = { style: {"height":"1rem","width":"0.8rem"} }
const _hoisted_15 = {
  key: 7,
  class: "dropdownItem border-bottom"
}
const _hoisted_16 = { style: {"height":"1rem","width":"0.8rem"} }
const _hoisted_17 = {
  key: 8,
  class: "dropdownItem"
}
const _hoisted_18 = { style: {"height":"1rem","width":"0.8rem"} }
const _hoisted_19 = { class: "dropdownItem" }

import { computed, nextTick, onBeforeUnmount, ref, watch } from "vue";
import { ElSwitch } from "element-plus";
import i18n from "@/core/i18n/i18n";
import { canRemoveNode } from "@/flow/utils/nodeUtils";

interface IProps {
  left: number;
  top: number;
  isMenuVisible: boolean;
  step: any;
  clonedStep: any;
  isLoop: boolean;
  isLoopStep: boolean;
  isNextStepLoop: boolean;
  isNextStepLoopEnd: boolean;
  isRouterNode?: boolean;
  canAddAfterNode?: boolean;
  isSkipped?: boolean;
  selectedNodeId?: string | null;
  canSkip?: boolean;
  canEnable?: boolean;
  enableDisabled?: boolean;
  anchorEl?: HTMLElement | null;
  nodes?: any;
  edges?: any[];
}

/*
 * Emits are defined as an array because these events do not need typed payloads
 * in this component.
 */
const SWITCH_CLOSE_DELAY_MS = 260;

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomDropdown',
  props: {
    left: { default: 0 },
    top: { default: 0 },
    isMenuVisible: { type: Boolean, default: false },
    step: {},
    clonedStep: {},
    isLoop: { type: Boolean },
    isLoopStep: { type: Boolean },
    isNextStepLoop: { type: Boolean },
    isNextStepLoopEnd: { type: Boolean, default: false },
    isRouterNode: { type: Boolean, default: false },
    canAddAfterNode: { type: Boolean, default: true },
    isSkipped: { type: Boolean, default: false },
    selectedNodeId: { default: null },
    canSkip: { type: Boolean, default: true },
    canEnable: { type: Boolean, default: false },
    enableDisabled: { type: Boolean, default: false },
    anchorEl: { default: null },
    nodes: {},
    edges: {}
  },
  emits: [
  "setSelectedNodeId", // Emitted when a node is deselected (set to null)
  "addNew", // Emitted when 'Add New' is clicked
  "openFilter", // Emitted when 'Open Filter' is clicked
  "addRouter", // Emitted when 'Add Router' is clicked
  "loop", // Emitted when 'Loop' is clicked
  "end", // Emitted when 'End' is clicked
  "delay", // Emitted when 'Delay' is clicked
  "remove", // Emitted when 'Remove' is clicked
  "clone", // Emitted when 'Clone Step' is clicked
  "pasteStep", // Emitted when 'Paste Step' is clicked
  "toggleLock", // Emitted when 'Toggle Lock/Unlock' is clicked
  "skip",
  "enable",
],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

/* Default prop values */
const props = __props;

const { t } = i18n.global;
const dropdownRef = ref<HTMLElement | null>(null);
const dropdownStyle = ref({
  top: "0px",
  left: "0px",
});
let frameId: number | null = null;
let closeMenuTimeoutId: ReturnType<typeof window.setTimeout> | null = null;
const skipToggleDisabled = computed(() =>
  props.isSkipped ? !props.canEnable || props.enableDisabled : !props.canSkip
);

function stopPositionLoop() {
  if (frameId !== null) {
    cancelAnimationFrame(frameId);
    frameId = null;
  }
}

function clearCloseMenuTimeout() {
  if (closeMenuTimeoutId !== null) {
    window.clearTimeout(closeMenuTimeoutId);
    closeMenuTimeoutId = null;
  }
}

function isInsideDropdown(element: Element | null) {
  if (!dropdownRef.value || !element) {
    return false;
  }

  return dropdownRef.value === element || dropdownRef.value.contains(element);
}

function isAnchorVisible(anchorEl: HTMLElement) {
  if (!anchorEl.isConnected) {
    return false;
  }

  const anchorRoot =
    (anchorEl.closest(".closest-node-container") as HTMLElement | null) ??
    anchorEl;
  const rect = anchorRoot.getBoundingClientRect();

  if (rect.width <= 0 || rect.height <= 0) {
    return false;
  }

  const visibleLeft = Math.max(rect.left, 0);
  const visibleTop = Math.max(rect.top, 0);
  const visibleRight = Math.min(rect.right, window.innerWidth);
  const visibleBottom = Math.min(rect.bottom, window.innerHeight);

  if (visibleRight <= visibleLeft || visibleBottom <= visibleTop) {
    return false;
  }

  const samplePoints = [
    {
      x: (visibleLeft + visibleRight) / 2,
      y: (visibleTop + visibleBottom) / 2,
    },
    {
      x: visibleLeft + Math.min(16, (visibleRight - visibleLeft) / 2),
      y: visibleTop + Math.min(16, (visibleBottom - visibleTop) / 2),
    },
  ];

  return samplePoints.some(({ x, y }) => {
    const firstRelevantElement = document
      .elementsFromPoint(Math.round(x), Math.round(y))
      .find((element) => !isInsideDropdown(element));

    if (!firstRelevantElement) {
      return false;
    }

    return (
      firstRelevantElement === anchorRoot ||
      anchorRoot.contains(firstRelevantElement) ||
      firstRelevantElement.contains(anchorRoot)
    );
  });
}

function syncDropdownPosition() {
  const { anchorEl } = props;

  if (!props.isMenuVisible || !anchorEl) {
    return;
  }

  if (!isAnchorVisible(anchorEl)) {
    stopPositionLoop();
    emit("setSelectedNodeId", null);
    return;
  }

  const anchorRect = anchorEl.getBoundingClientRect();
  const anchorWidth = anchorEl.offsetWidth || anchorRect.width || 1;
  const anchorHeight = anchorEl.offsetHeight || anchorRect.height || 1;

  let nextLeft =
    anchorRect.left + (anchorRect.width * props.left) / anchorWidth;
  let nextTop = anchorRect.top + (anchorRect.height * props.top) / anchorHeight;

  if (dropdownRef.value) {
    const maxLeft = window.innerWidth - dropdownRef.value.offsetWidth - 8;
    const maxTop = window.innerHeight - dropdownRef.value.offsetHeight - 8;

    nextLeft = Math.max(8, Math.min(nextLeft, maxLeft));
    nextTop = Math.max(8, Math.min(nextTop, maxTop));
  }

  dropdownStyle.value = {
    top: `${Math.round(nextTop)}px`,
    left: `${Math.round(nextLeft)}px`,
  };
}

function startPositionLoop() {
  stopPositionLoop();

  const tick = () => {
    syncDropdownPosition();

    if (props.isMenuVisible) {
      frameId = requestAnimationFrame(tick);
    }
  };

  tick();
}

watch(
  () => props.isMenuVisible,
  async (isVisible) => {
    if (!isVisible) {
      stopPositionLoop();
      clearCloseMenuTimeout();
      return;
    }

    await nextTick();
    startPositionLoop();
  },
  { immediate: true }
);

watch(
  () => props.anchorEl,
  async () => {
    if (!props.isMenuVisible) {
      return;
    }

    await nextTick();
    syncDropdownPosition();
  }
);

onBeforeUnmount(() => {
  stopPositionLoop();
  clearCloseMenuTimeout();
});

/* Function to check if the step contains a specific type ('LOOP' or 'END') */
// function checkForLoopAndEndByType(type, step) {
//   let contains = false;
//   if (step) {
//     if (step.translations) {
//       step.translations.forEach((item) => {
//         if (item.expressionType && item.expressionType === type) {
//           contains = true;
//         }
//       });
//     }
//   }
//   return contains;
// }

/* Function to emit an event and deselect a node by setting its ID to null */
function emitFuntions(fn, disabled = false) {
  if (disabled) return;
  emit(fn);
  emit("setSelectedNodeId", null);
}

function toggleSkipState() {
  if (skipToggleDisabled.value) return;

  const scheduledNodeOrigId = props.step?.data?.origId;
  clearCloseMenuTimeout();
  emit(props.isSkipped ? "enable" : "skip");
  closeMenuTimeoutId = window.setTimeout(() => {
    closeMenuTimeoutId = null;
    if (
      scheduledNodeOrigId != null &&
      props.selectedNodeId === scheduledNodeOrigId
    ) {
      emit("setSelectedNodeId", null);
    }
  }, SWITCH_CLOSE_DELAY_MS);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.isMenuVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "dropdownRef",
          ref: dropdownRef,
          class: "dropdown",
          style: _normalizeStyle(dropdownStyle.value),
          onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
          onMousedown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
          onContextmenu: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"]))
        }, [
          (!_ctx.isRouterNode && _ctx.canAddAfterNode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emitFuntions('addNew')), ["stop"])),
                  class: "flex items-top dropdownItemContent"
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "fa-fw",
                      icon: "plus"
                    })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("Common.AddNewStep")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isRouterNode && !_ctx.isLoop && !_ctx.isNextStepLoopEnd)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emitFuntions('openFilter')), ["stop"])),
                  class: "flex items-top dropdownItemContent"
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "fa-fw",
                      icon: "filter"
                    })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("Common.AddFilter")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isRouterNode && _ctx.canAddAfterNode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (emitFuntions('addRouter')), ["stop"])),
                  class: "flex items-top dropdownItemContent"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "fa-fw",
                      icon: "code-branch"
                    })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("Common.AddCondition")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isRouterNode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (emitFuntions('toggleLock')), ["stop"])),
                  class: "flex items-top dropdownItemContent"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "fa-fw",
                      icon: _ctx.step?.data?.lock ? 'lock-open' : 'lock'
                    }, null, 8, ["icon"])
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)(`Common.${_ctx.step?.data?.lock ? "UnLock" : "Lock"}`)), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isRouterNode && !_ctx.isLoop && _ctx.canAddAfterNode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", {
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (emitFuntions('loop')), ["stop"])),
                  class: "flex items-top dropdownItemContent"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "fa-fw",
                      icon: "redo"
                    })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("Common.AddLoop")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isRouterNode && !_ctx.isLoop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", {
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (emitFuntions('delay')), ["stop"])),
                  class: "flex items-top dropdownItemContent"
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "fa-fw",
                      icon: "hourglass-start"
                    })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("Common.AddDelay")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isRouterNode && !_ctx.isLoop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", {
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (emitFuntions('clone')), ["stop"])),
                  class: "flex items-top dropdownItemContent"
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "fa-fw",
                      icon: "clone"
                    })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("Flow.CloneStep")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.clonedStep && !_ctx.isRouterNode && !_ctx.isLoop && _ctx.canAddAfterNode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", {
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (emitFuntions('pasteStep')), ["stop"])),
                  class: "flex items-top dropdownItemContent"
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "fa-fw",
                      icon: "clone"
                    })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("Flow.PasteStep")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (
          Number(_ctx.step.label) > 0 &&
          !_ctx.isRouterNode &&
          _unref(canRemoveNode)(_ctx.step.data.origId, _ctx.nodes, _ctx.edges)
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", {
                  onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (emitFuntions('remove')), ["stop"])),
                  class: "flex items-top dropdownItemContent"
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "fa-fw",
                      icon: "times"
                    })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("Common.Remove")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", {
              class: _normalizeClass([
            'flex dropdownItemContent switchOnlyContent',
            { disabled: skipToggleDisabled.value },
          ])
            }, [
              _createVNode(_unref(ElSwitch), {
                "model-value": !_ctx.isSkipped,
                disabled: skipToggleDisabled.value,
                "active-color": "#5022a6",
                class: "context-menu-switch",
                width: 36,
                onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
                onChange: toggleSkipState
              }, null, 8, ["model-value", "disabled"])
            ], 2)
          ])
        ], 36))
      : _createCommentVNode("", true)
  ]))
}
}

})